import { z } from 'zod';

export const AhqFindTalentSchema = z.object({
  candidateId: z.string().uuid(),
});
export type AhqFindTalent = z.infer<typeof AhqFindTalentSchema>;
